var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DB_NAME = 'tradeveris-wallet-passkey';
var PRF_UNSUPPORTED_KEY = 'tradeveris-passkey-prf-unsupported';
var DB_VERSION = 1;
var STORE_NAME = 'passkey-record';
var RECORD_KEY = 'record';
var PRF_SALT_LABEL = 'tradeveris-wallet-passkey-prf-v1';
// ── IndexedDB helpers ────────────────────────────────────────────────────────
function openDb() {
    return new Promise(function (resolve, reject) {
        var req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = function () {
            req.result.createObjectStore(STORE_NAME);
        };
        req.onsuccess = function () { return resolve(req.result); };
        req.onerror = function () { return reject(req.error); };
    });
}
function getRecord() {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openDb()];
                case 1:
                    db = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var tx = db.transaction(STORE_NAME, 'readonly');
                            var req = tx.objectStore(STORE_NAME).get(RECORD_KEY);
                            req.onsuccess = function () { var _a; return resolve((_a = req.result) !== null && _a !== void 0 ? _a : null); };
                            req.onerror = function () { return reject(req.error); };
                            tx.oncomplete = function () { return db.close(); };
                        })];
            }
        });
    });
}
function saveRecord(record) {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openDb()];
                case 1:
                    db = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var tx = db.transaction(STORE_NAME, 'readwrite');
                            var req = tx.objectStore(STORE_NAME).put(record, RECORD_KEY);
                            req.onerror = function () { return reject(req.error); };
                            tx.oncomplete = function () { db.close(); resolve(); };
                            tx.onerror = function () { return reject(tx.error); };
                            tx.onabort = function () { var _a; return reject((_a = tx.error) !== null && _a !== void 0 ? _a : new Error('Transaction aborted')); };
                        })];
            }
        });
    });
}
function deleteRecord() {
    return __awaiter(this, void 0, void 0, function () {
        var db;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openDb()];
                case 1:
                    db = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var tx = db.transaction(STORE_NAME, 'readwrite');
                            var req = tx.objectStore(STORE_NAME).delete(RECORD_KEY);
                            req.onerror = function () { return reject(req.error); };
                            tx.oncomplete = function () { db.close(); resolve(); };
                            tx.onerror = function () { return reject(tx.error); };
                            tx.onabort = function () { var _a; return reject((_a = tx.error) !== null && _a !== void 0 ? _a : new Error('Transaction aborted')); };
                        })];
            }
        });
    });
}
// ── Encoding helpers ─────────────────────────────────────────────────────────
function toBase64Url(buffer) {
    var bytes = new Uint8Array(buffer);
    var str = '';
    for (var i = 0; i < bytes.length; i++)
        str += String.fromCharCode(bytes[i]);
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function fromBase64Url(str) {
    var padded = str.replace(/-/g, '+').replace(/_/g, '/');
    var padLength = (4 - (padded.length % 4)) % 4;
    if (padLength > 0) {
        padded = padded.padEnd(padded.length + padLength, '=');
    }
    var binary = atob(padded);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
}
// ── Crypto helpers ───────────────────────────────────────────────────────────
function getPrfSalt() {
    return new TextEncoder().encode(PRF_SALT_LABEL).buffer;
}
function deriveAesKey(prfOutput, hkdfSalt) {
    return __awaiter(this, void 0, void 0, function () {
        var keyMaterial;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, crypto.subtle.importKey('raw', prfOutput, { name: 'HKDF' }, false, ['deriveKey'])];
                case 1:
                    keyMaterial = _a.sent();
                    return [2 /*return*/, crypto.subtle.deriveKey({
                            name: 'HKDF',
                            hash: 'SHA-256',
                            salt: hkdfSalt,
                            info: new TextEncoder().encode('tradeveris-wallet-aes-key-v1'),
                        }, keyMaterial, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt'])];
            }
        });
    });
}
function encryptPasscode(passcode, aesKey) {
    return __awaiter(this, void 0, void 0, function () {
        var iv, encoded, ciphertext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    iv = crypto.getRandomValues(new Uint8Array(12));
                    encoded = new TextEncoder().encode(passcode);
                    return [4 /*yield*/, crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, aesKey, encoded)];
                case 1:
                    ciphertext = _a.sent();
                    return [2 /*return*/, {
                            iv: toBase64Url(iv.buffer),
                            ciphertext: toBase64Url(ciphertext),
                        }];
            }
        });
    });
}
function decryptPasscode(ciphertext, iv, aesKey) {
    return __awaiter(this, void 0, void 0, function () {
        var decrypted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, crypto.subtle.decrypt({ name: 'AES-GCM', iv: fromBase64Url(iv) }, aesKey, fromBase64Url(ciphertext))];
                case 1:
                    decrypted = _a.sent();
                    return [2 /*return*/, new TextDecoder().decode(decrypted)];
            }
        });
    });
}
function getCurrentRpId() {
    return window.location.hostname;
}
// ── PRF helpers ──────────────────────────────────────────────────────────────
function extractPrfOutput(result) {
    var _a, _b;
    var ext = result.getClientExtensionResults();
    var prf = ext === null || ext === void 0 ? void 0 : ext.prf;
    return (_b = (_a = prf === null || prf === void 0 ? void 0 : prf.results) === null || _a === void 0 ? void 0 : _a.first) !== null && _b !== void 0 ? _b : null;
}
// ── Public API ───────────────────────────────────────────────────────────────
export function isPasskeySupported() {
    return __awaiter(this, void 0, void 0, function () {
        var hasPlatformAuth, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(window.isSecureContext &&
                        typeof navigator.credentials !== 'undefined' &&
                        typeof navigator.credentials.create === 'function' &&
                        typeof navigator.credentials.get === 'function' &&
                        typeof window.PublicKeyCredential !== 'undefined')) {
                        return [2 /*return*/, false];
                    }
                    // If a previous setup attempt confirmed PRF is unavailable on this browser, don't offer it again.
                    if (localStorage.getItem(PRF_UNSUPPORTED_KEY))
                        return [2 /*return*/, false];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()];
                case 2:
                    hasPlatformAuth = _c.sent();
                    if (!hasPlatformAuth)
                        return [2 /*return*/, false];
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    return [2 /*return*/, false];
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var req = indexedDB.open('tradeveris-passkey-probe');
                            req.onsuccess = function () { req.result.close(); indexedDB.deleteDatabase('tradeveris-passkey-probe'); resolve(); };
                            req.onerror = function () { return reject(req.error); };
                            req.onblocked = function () { return reject(new Error('IndexedDB blocked')); };
                        })];
                case 5:
                    _c.sent();
                    return [2 /*return*/, true];
                case 6:
                    _b = _c.sent();
                    return [2 /*return*/, false];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function hasLocalPasskeyLink() {
    return __awaiter(this, void 0, void 0, function () {
        var record, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getRecord()];
                case 1:
                    record = _b.sent();
                    return [2 /*return*/, record !== null && record.rpId === getCurrentRpId()];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function setupPasskey(passcode, displayName, aid) {
    return __awaiter(this, void 0, void 0, function () {
        var rpId, userId, createOptions, credential, prfOutput, getOptions, assertion, hkdfSalt, aesKey, _a, iv, ciphertext, record, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    rpId = getCurrentRpId();
                    userId = new TextEncoder().encode(aid);
                    createOptions = {
                        rp: { id: rpId, name: 'TradeVeris Wallet' },
                        user: {
                            id: userId,
                            name: displayName,
                            displayName: displayName,
                        },
                        challenge: crypto.getRandomValues(new Uint8Array(32)),
                        pubKeyCredParams: [
                            { type: 'public-key', alg: -7 }, // ES256
                            { type: 'public-key', alg: -257 }, // RS256
                        ],
                        authenticatorSelection: {
                            authenticatorAttachment: 'platform',
                            userVerification: 'required',
                            residentKey: 'preferred',
                        },
                        attestation: 'none',
                        extensions: {
                            prf: { eval: { first: getPrfSalt() } },
                            credentialProtectionPolicy: 'userVerificationRequired',
                        },
                    };
                    return [4 /*yield*/, navigator.credentials.create({ publicKey: createOptions })];
                case 1:
                    credential = _b.sent();
                    if (!credential)
                        return [2 /*return*/, false];
                    prfOutput = extractPrfOutput(credential);
                    if (!!prfOutput) return [3 /*break*/, 3];
                    getOptions = {
                        rpId: rpId,
                        challenge: crypto.getRandomValues(new Uint8Array(32)),
                        allowCredentials: [{ type: 'public-key', id: credential.rawId }],
                        userVerification: 'required',
                        extensions: {
                            prf: { eval: { first: getPrfSalt() } },
                        },
                    };
                    return [4 /*yield*/, navigator.credentials.get({ publicKey: getOptions })];
                case 2:
                    assertion = _b.sent();
                    if (!assertion)
                        return [2 /*return*/, false];
                    prfOutput = extractPrfOutput(assertion);
                    _b.label = 3;
                case 3:
                    if (!prfOutput) {
                        // Authenticator does not support PRF — record this so we don't prompt again.
                        localStorage.setItem(PRF_UNSUPPORTED_KEY, '1');
                        return [2 /*return*/, false];
                    }
                    hkdfSalt = crypto.getRandomValues(new Uint8Array(32));
                    return [4 /*yield*/, deriveAesKey(prfOutput, hkdfSalt.buffer)];
                case 4:
                    aesKey = _b.sent();
                    return [4 /*yield*/, encryptPasscode(passcode, aesKey)];
                case 5:
                    _a = _b.sent(), iv = _a.iv, ciphertext = _a.ciphertext;
                    record = {
                        version: 1,
                        credentialId: toBase64Url(credential.rawId),
                        rpId: rpId,
                        hkdfSalt: toBase64Url(hkdfSalt.buffer),
                        iv: iv,
                        ciphertext: ciphertext,
                    };
                    return [4 /*yield*/, saveRecord(record)];
                case 6:
                    _b.sent();
                    return [2 /*return*/, true];
                case 7:
                    err_1 = _b.sent();
                    // User cancellation throws DOMException with name 'NotAllowedError' — treat as graceful failure.
                    if (err_1 instanceof DOMException && err_1.name === 'NotAllowedError')
                        return [2 /*return*/, false];
                    throw err_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
export function loginWithPasskey() {
    return __awaiter(this, void 0, void 0, function () {
        var record, getOptions, assertion, prfOutput, aesKey, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, getRecord()];
                case 1:
                    record = _a.sent();
                    if (!record || record.rpId !== getCurrentRpId())
                        return [2 /*return*/, null];
                    getOptions = {
                        rpId: record.rpId,
                        challenge: crypto.getRandomValues(new Uint8Array(32)),
                        allowCredentials: [{ type: 'public-key', id: fromBase64Url(record.credentialId) }],
                        userVerification: 'required',
                        extensions: {
                            prf: { eval: { first: getPrfSalt() } },
                        },
                    };
                    return [4 /*yield*/, navigator.credentials.get({ publicKey: getOptions })];
                case 2:
                    assertion = _a.sent();
                    if (!assertion)
                        return [2 /*return*/, null];
                    prfOutput = extractPrfOutput(assertion);
                    if (!prfOutput)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, deriveAesKey(prfOutput, fromBase64Url(record.hkdfSalt))];
                case 3:
                    aesKey = _a.sent();
                    return [4 /*yield*/, decryptPasscode(record.ciphertext, record.iv, aesKey)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    err_2 = _a.sent();
                    if (err_2 instanceof DOMException && err_2.name === 'NotAllowedError')
                        return [2 /*return*/, null];
                    throw err_2;
                case 6: return [2 /*return*/];
            }
        });
    });
}
export function unlinkPasskey() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteRecord()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
